import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearLoginData, selectLoggedInData } from '../store/slices/api/auth/loginSlice';
import { NAVIGATION } from '../lib/navigation';
import { MdEdit, MdLogout } from 'react-icons/md';
import avatar from '../assets/images/avatar.png'

const ProfileDropdown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const loggedInData = useSelector(selectLoggedInData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    dispatch(clearLoginData());
    localStorage.clear();
    navigate(NAVIGATION.AUTH_NAVIGATION.LOGIN);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="flex items-center space-x-2 focus:outline-none"
      >
        <img
          src={avatar}
          alt="Profile"
          className="h-10 w-10 rounded-full object-cover"
        />
      </button>

      {dropdownOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 shadow-lg rounded-lg py-2 z-50 transition-all">
          <div className="px-4 py-2 flex items-center space-x-3 hover:bg-gray-50 transition-colors rounded-t-lg">
            <img
              src={avatar}
              alt="Profile"
              className="h-10 w-10 rounded-full object-cover"
            />
            <div>
              <p className="font-semibold text-gray-700">{loggedInData && loggedInData?.authUserData?.admin_name}</p>
              <span className="text-sm text-gray-500">{`Administrator`}</span>
            </div>
          </div>

          <hr className="my-2 border-gray-200" />

          <Link to={NAVIGATION.INNER_NAVIGATION.SETTING.CHANGE_PASSWORD}

            className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors rounded-lg"
          >
            <MdEdit className="w-5 h-5 mr-2 text-red-500" />
            Change Password
          </Link>
          {/* Logout Button */}
          <button
            onClick={logout}
            className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors rounded-lg"
          >
            <MdLogout className="w-5 h-5 mr-2 text-red-500" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
